import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { TrainingItemGroupSearchResult } from '../../../../training-item-group-search/models/training-item-group-search-result';
import { TrainingItemGroupSearchComponent } from '../../../../training-item-group-search/training-item-group-search/training-item-group-search.component';
import { TrainingItemGroupDetails } from '../../../../training-item/models/training-item-group-detail';
import { TrainingItemGroupService } from '../../../../training-item/services/training-item-group.service';
import { EmployeesTrainingPlanPersistenceService } from '../../services/employees-training-plan-persistence.service';
import { EqmsScopeManagementService } from '../../../../shared/services/eqms-scope-management.service';
import { EmployeesTrainingPlanService } from '../../services/employees-training-plan.service';
import { EmployeesTrainingPlanConstants } from '../../employees-training-plan.constants';
import { UserTrainingPlanDTO } from '../../../../my-space/user-training-plan/models/user-training-plan';
import { cloneDeep } from 'lodash-es';
import { SelectedUserScopesDTO } from '../../models/selectedUserScopesDTO';
import { TrainingPlanDetailsDto } from '../../../../my-space/user-training-plan/models/trainingPlanDetailsDto';
import { UserProfileConstants } from '../../../../my-space/user-profile/user-profile-constants';

@Component({
  selector: 'app-employee-training-plan-training-item-group-details',
  templateUrl: './employee-training-plan-training-item-group-details.component.html',
  styleUrls: ['./employee-training-plan-training-item-group-details.component.scss']
})
export class EmployeeTrainingPlanTrainingItemGroupDetailsComponent implements OnInit{
  @Input() userScopes!: SelectedUserScopesDTO | undefined;

  selectedTrainingItemGroups: TrainingItemGroupSearchResult[] = [];
  displayDataCollected: string[] = [];
  trainingItemGroupSearchResult: TrainingItemGroupSearchResult[] = [];
  trainingItemGroupDetails: TrainingItemGroupDetails[] = [];
  showAddButton: boolean = false;
  isTrainingPlanSaveInProgress: boolean = false;
  TrainingPlanSaveInProgressMessage : string = EmployeesTrainingPlanConstants.EmployeeTrainingPlan_SaveInProgress;
  addAndClose: boolean = false;
  eQMSScopes: number[] = [];
  trainingItemNumbers: string[] = [];
  validTrainingItemGroups: string[] = [];
  userTrainingPlan: UserTrainingPlanDTO[] = [];
  items: MenuItem[] = [];
  errorCount: number = 0;
  scope?: number;
  isUpdate: boolean = false;
  @Input() userPUID: string | undefined;
  trainingPlanDetails ?: TrainingPlanDetailsDto
  
  @ViewChild(TrainingItemGroupSearchComponent)
  private trainingGroupItemSearch!: TrainingItemGroupSearchComponent;
  feature:string = EmployeesTrainingPlanConstants.MyEmployee_TrainingPlan_Feature;

  constructor(private messageService: MessageService,
    private trainingItemGroupService: TrainingItemGroupService,
    private employeesTrainingPlanPersistenceService: EmployeesTrainingPlanPersistenceService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private employeesTrainingPlanService : EmployeesTrainingPlanService) {
    this.items = [
      {
        label: 'Add',
        command: this.add
      }
    ]
  }

  ngOnInit(): void {
    this.employeesTrainingPlanPersistenceService.TrainingPlanSaveInProgress$.
      subscribe((TrainingPlanSaveStatus) => {
        this.isTrainingPlanSaveInProgress = TrainingPlanSaveStatus;
      });
    this.employeesTrainingPlanPersistenceService.closeAndResetTrainingPlanSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetTrainingPlanSlider(); }
    })
  }


  add = () => {
    this.addAndClose = false;
    this.getLinkedItems(this.addAndClose);
  };

  closeAndResetTrainingPlanSlider() {
    this.selectedTrainingItemGroups = [];
    this.displayDataCollected = [];
    this.trainingItemGroupSearchResult = [];
    this.showAddButton = false;
  }

  onSelectionOrDeselection = (trainingItemGroups: TrainingItemGroupSearchResult[]) => {
    let selectedTrainingItemGroupsList: string[] = [];
    trainingItemGroups.forEach(element => {
      selectedTrainingItemGroupsList.push(element.number);
    });
    this.displayDataCollected = []
    this.displayDataCollected = selectedTrainingItemGroupsList;
    this.selectedTrainingItemGroups = [];
    this.selectedTrainingItemGroups = cloneDeep(trainingItemGroups);
  }

  showOrHideAddButton = (displayAddBtn: boolean) => {
    this.showAddButton = displayAddBtn;
  }
  addTrainingPlanAndClose() {
    this.addAndClose = true;
    this.getLinkedItems(this.addAndClose);
  }

  getLinkedItems(addAndClose: boolean) {
    this.eQMSScopes = [];
    this.displayDataCollected = Object.assign([], this.displayDataCollected);
    this.errorCount = 0;

    // Get Training items of the selected training item groups
    this.trainingItemGroupService.getTrainingItems(this.displayDataCollected).subscribe((trainingGroupItemsDetails: any[]) => {
      this.trainingItemGroupDetails = trainingGroupItemsDetails;
      this.validateAndCreateOrUpdateTrainingItem(addAndClose);
      this.trainingGroupItemSearch.getLinkedItemsSelection();
    });
  }

  validateAndCreateOrUpdateTrainingItem(addAndClose: boolean) {
    // Only validate that at least one item is selected
    if (this.displayDataCollected.length <= 0) {
      this.validateToSelectAtleastOneTrainingItem();
      return;
    }
    
    // Proceed to validate scopes
    this.getParentScopesAndCompare(addAndClose);
  }



  getParentScopesAndCompare(addAndClose: boolean) {
    const scopes: any[] = [];
    scopes.push(this.userScopes?.eQMSPrimaryScope);
      this.userScopes?.ancestors?.forEach((ele : number) => {
        scopes.push(ele);
      });

      //For descendants
      this.userScopes?.descendants?.forEach((ele : number) => {
        scopes.push(ele);
      });
    const matchingtrainingItemGroups: any[] = [];
    const mismatchedtrainingItemGroups: any[] = [];

    this.displayDataCollected.forEach((data) => {
      var trainingItemGroupDetail = this.trainingItemGroupDetails.filter((tig) => { return tig.number === data });
      const { eQMSScopes } = trainingItemGroupDetail[0];
      const hasMatch = eQMSScopes.some((scope: number) => scopes.includes(scope));
      if (hasMatch) {
        matchingtrainingItemGroups.push(data);
      } else {
        mismatchedtrainingItemGroups.push(data);
      }
    });
    if (mismatchedtrainingItemGroups.length) {
      this.displayScopeValidationMessage(mismatchedtrainingItemGroups);
    }
    if (matchingtrainingItemGroups.length) {
      this.selectedItems(matchingtrainingItemGroups);
      // Always call addTrainingRequirement (backend will handle duplicates)
      this.addTrainingRequirement(matchingtrainingItemGroups, addAndClose);
    }
  }

  addTrainingRequirement(matchingtrainingItemGroups: any[], addAndClose: boolean) {
    let matchingTrainingItemGroupsDetails = this.trainingItemsOfValidTrainingItemGroups(matchingtrainingItemGroups);
    this.employeesTrainingPlanPersistenceService.prepareDataForTrainingItemGroupTrainingItem(matchingTrainingItemGroupsDetails, this.userPUID);
    
    if(this.employeesTrainingPlanPersistenceService.duplicateTrainingItemsNumber.length > 0){
      // Show Warning Message
      const trainingItemCode = this.employeesTrainingPlanPersistenceService.duplicateTrainingItemsNumber.map((item) => `${item}`).join(",");
      const validationMessage = EmployeesTrainingPlanConstants.TrainingPlan_Warning_TrainingItemAlreadyPresentMessage.replace('TrainingItems',
        `\n${trainingItemCode}`
      );
      this.messageService.add({
        severity: EmployeesTrainingPlanConstants.Severity_Warning,
        summary: `${validationMessage}`,
        sticky: true
      });
    }
    
    this.employeesTrainingPlanPersistenceService.addTrainingPlan(addAndClose);
  }

  selectedItems(serviceData: any[]) {
    if (!this.validTrainingItemGroups || this.validTrainingItemGroups.length === 0) {
      this.validTrainingItemGroups = serviceData;
    } else {
      this.validTrainingItemGroups.push(...serviceData);
    }
  }

  displayScopeValidationMessage(mismatchedtrainingItemGroups: any[]) {
    this.errorCount = 0;
    const trainingItemGroupNumbersString = mismatchedtrainingItemGroups.map((trainingItemGroup) => `  ${trainingItemGroup}`).join(', ');
    const validationMessage = EmployeesTrainingPlanConstants.Selected_TrainingItemGroupscopes_Not_Matching_Error_Message.replace(
      'TrainingItemGroupNumbers',
      `\n${trainingItemGroupNumbersString}`
    );
    this.messageService.add({
      severity: EmployeesTrainingPlanConstants.Severity_Err,
      summary: `${validationMessage}`,
      sticky: true
    });
    this.errorCount++;
  }

  validateToSelectAtleastOneTrainingItem() {
    this.errorCount = 0;
    this.messageService.add({
      severity: EmployeesTrainingPlanConstants.Severity_Err,
      summary: `${EmployeesTrainingPlanConstants.AtleastOneTrainingItem_ShouldBeSelected}`,
      sticky: true
    });
    this.errorCount++;
  }

  trainingItemsOfValidTrainingItemGroups(trainingItemGroupNumbers: string[]): TrainingItemGroupDetails[] {
    // Return training item groups matching the numbers (backend will handle duplicates)
    return this.trainingItemGroupDetails.filter(item => trainingItemGroupNumbers.includes(item.number));
  }

}
